import styled from "styled-components";
import { useSelector, useDispatch, ACTIONS } from "../routes/StateProvider";

const BannerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: ${({ color }) => {
    if (color === "PROBLEM") return "#e53e3e";
    if (color === "WARNING") return "#dd6b20";
    if (color === "REWARD") return "#38a169";
    return "#3182ce";
  }};
  color: white;
  font-size: 14px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 0 4px;
`;

const BannerCard = ({ text, color, onClose }) => (
  <BannerWrapper color={color}>
    <span>{text}</span>
    {onClose && <CloseButton onClick={onClose}>&times;</CloseButton>}
  </BannerWrapper>
);

const BannerList = () => {
  const currentBanner = useSelector(state => state.banners[0]);
  const dispatch = useDispatch();

  const handleClose = () => {
    if (currentBanner && currentBanner.onClose) {
      currentBanner.onClose();
    }
    dispatch({ type: ACTIONS.removeBanner });
  };

  return (
    <div>
      {currentBanner && (
        <BannerCard
          id={currentBanner.id}
          text={currentBanner.message}
          color={currentBanner.color}
          onClose={handleClose}
        />
      )}
    </div>
  );
};

export default BannerList;
